"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function get() {
    return _index.Container;
  }
});
exports.DrawerContent = void 0;
Object.defineProperty(exports, "Mask", {
  enumerable: true,
  get: function get() {
    return _index.Mask;
  }
});

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _mediaQueries = _interopRequireDefault(require("../../../mediaQueries"));

var _Drawer = require("../Drawer");

var _index = require("../Drawer/index.styles");

var _templateObject;

var drawerWidth = '36.5rem';
var topOfStackDrawerGutter = '2rem';

var DrawerContent = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "indexstyles__DrawerContent",
  componentId: "sc-g0bial-0"
})(["", " width:", ";transform:translateX(", ");", " &.slide-in-enter-active{transition:transform ", "ms ease-out;transform:translateX(", ");}&.slide-in-enter-done{transform:translateX(", ");}&.slide-aside-enter-active{transform:translateX(0);transition:transform ", "ms ease-out;}&.slide-aside-enter-done{transform:translateX(0);}&.slide-aside-exit{transform:translateX(", ");transition:transform ", "ms ease-in;}&.slide-in-exit{transform:translateX(", ");}&.slide-in-exit-active{transform:translateX(", ");transition:transform ", "ms ease-in;}"], _index.drawerContentStyle, drawerWidth, drawerWidth, _mediaQueries["default"].smUp(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    padding-right: ", ";\n  "])), function (p) {
  return "calc(".concat(p.theme.tokens.spacing08, " + ").concat(topOfStackDrawerGutter, ")");
}), function () {
  return _Drawer.ANIMATION_SPEED_ENTER;
}, topOfStackDrawerGutter, topOfStackDrawerGutter, function () {
  return _Drawer.ANIMATION_SPEED_ENTER;
}, topOfStackDrawerGutter, function () {
  return _Drawer.ANIMATION_SPEED_EXIT;
}, topOfStackDrawerGutter, drawerWidth, function () {
  return _Drawer.ANIMATION_SPEED_EXIT;
});

exports.DrawerContent = DrawerContent;